import { z } from 'zod';

import type {
  ExportShipmentDailyRegularRequest,
  ExportShipmentDailyRegularResponse,
  ShipmentDailyRegularHeader,
  ShipmentDailyRegularRow,
} from './export-shipment-daily-regular.dto.js';
import { IsoDateSchema } from './shipments-types.js';
import { ReportableWeightLbSchema } from '../reportable-weight.schema.js';

const nonNegativeIntSchema = z.number().int().min(0);
const trimmedStringSchema = z.string().trim().min(1);

const ShipmentDailyRegularHeaderSchema: z.ZodType<ShipmentDailyRegularHeader> = z
  .object({
    receivedWeightLb: ReportableWeightLbSchema.nullable(),
    timeZone: trimmedStringSchema,
  })
  .strict();

export const ShipmentDailyRegularRowSchema: z.ZodType<ShipmentDailyRegularRow> = z
  .object({
    purchaseDate: IsoDateSchema,
    swPhysicalLb: ReportableWeightLbSchema,
    swCrvLb: ReportableWeightLbSchema,
    sclCount: nonNegativeIntSchema,
    scsCount: nonNegativeIntSchema,
    sc25Count: nonNegativeIntSchema,
    qualityDiscountMoneyCents: nonNegativeIntSchema,
    qualityDiscountEquivalentLbs: ReportableWeightLbSchema,
    scrapWeightLb: ReportableWeightLbSchema,
    redemptionWeightLb: ReportableWeightLbSchema,
    totalWeightLb: ReportableWeightLbSchema,
    refundValueCents: nonNegativeIntSchema,
  })
  .strict();

export const ExportShipmentDailyRegularRequestSchema: z.ZodType<ExportShipmentDailyRegularRequest> =
  z
    .object({
      companyId: z.uuid(),
      shipmentId: z.uuid(),
    })
    .strict();

export const ExportShipmentDailyRegularResponseSchema: z.ZodType<ExportShipmentDailyRegularResponse> =
  z
    .object({
      header: ShipmentDailyRegularHeaderSchema,
      rows: z.array(ShipmentDailyRegularRowSchema),
    })
    .strict();
